import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import product from './product'
import solutions from './solutions'
import api from './api'
import resources from './resources'
import tools from './tools'
import contact50a660 from './contact'
/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
export const faq = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

faq.definition = {
    methods: ["get","head"],
    url: '/faq',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
faq.url = (options?: RouteQueryOptions) => {
    return faq.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
faq.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
faq.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: faq.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
const faqForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
faqForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::faq
* @see app/Http/Controllers/PublicController.php:146
* @route '/faq'
*/
faqForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

faq.form = faqForm

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: '/confidentialite',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
const privacyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
privacyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::privacy
* @see app/Http/Controllers/PublicController.php:151
* @route '/confidentialite'
*/
privacyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

privacy.form = privacyForm

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/cgu',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
const termsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
termsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::terms
* @see app/Http/Controllers/PublicController.php:156
* @route '/cgu'
*/
termsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

terms.form = termsForm

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
export const antiSpam = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: antiSpam.url(options),
    method: 'get',
})

antiSpam.definition = {
    methods: ["get","head"],
    url: '/anti-spam',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
antiSpam.url = (options?: RouteQueryOptions) => {
    return antiSpam.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
antiSpam.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: antiSpam.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
antiSpam.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: antiSpam.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
const antiSpamForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: antiSpam.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
antiSpamForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: antiSpam.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::antiSpam
* @see app/Http/Controllers/PublicController.php:161
* @route '/anti-spam'
*/
antiSpamForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: antiSpam.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

antiSpam.form = antiSpamForm

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
export const antiBanGuide = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: antiBanGuide.url(options),
    method: 'get',
})

antiBanGuide.definition = {
    methods: ["get","head"],
    url: '/prevenir-bannissement',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
antiBanGuide.url = (options?: RouteQueryOptions) => {
    return antiBanGuide.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
antiBanGuide.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: antiBanGuide.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
antiBanGuide.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: antiBanGuide.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
const antiBanGuideForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: antiBanGuide.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
antiBanGuideForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: antiBanGuide.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::antiBanGuide
* @see app/Http/Controllers/PublicController.php:166
* @route '/prevenir-bannissement'
*/
antiBanGuideForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: antiBanGuide.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

antiBanGuide.form = antiBanGuideForm

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/statut',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::status
* @see app/Http/Controllers/PublicController.php:171
* @route '/statut'
*/
statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

status.form = statusForm

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
export const pricing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

pricing.definition = {
    methods: ["get","head"],
    url: '/tarifs',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
pricing.url = (options?: RouteQueryOptions) => {
    return pricing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
pricing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
pricing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pricing.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
const pricingForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
pricingForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::pricing
* @see app/Http/Controllers/PublicController.php:181
* @route '/tarifs'
*/
pricingForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pricing.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pricing.form = pricingForm

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
export const security = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(options),
    method: 'get',
})

security.definition = {
    methods: ["get","head"],
    url: '/securite',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
security.url = (options?: RouteQueryOptions) => {
    return security.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
security.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
security.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: security.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
const securityForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: security.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
securityForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: security.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::security
* @see app/Http/Controllers/PublicController.php:218
* @route '/securite'
*/
securityForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: security.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

security.form = securityForm

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: '/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::contact
* @see app/Http/Controllers/PublicController.php:223
* @route '/contact'
*/
contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contact.form = contactForm

const publicMethod = {
    product: Object.assign(product, product),
    solutions: Object.assign(solutions, solutions),
    api: Object.assign(api, api),
    resources: Object.assign(resources, resources),
    tools: Object.assign(tools, tools),
    faq: Object.assign(faq, faq),
    privacy: Object.assign(privacy, privacy),
    terms: Object.assign(terms, terms),
    antiSpam: Object.assign(antiSpam, antiSpam),
    antiBanGuide: Object.assign(antiBanGuide, antiBanGuide),
    status: Object.assign(status, status),
    pricing: Object.assign(pricing, pricing),
    security: Object.assign(security, security),
    contact: Object.assign(contact, contact50a660),
}

export default publicMethod